import { render, staticRenderFns } from "./user-edit-form.html?vue&type=template&id=e60e482a&scoped=true&"
import script from "./user-edit-form.js?vue&type=script&lang=js&"
export * from "./user-edit-form.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60e482a",
  null
  
)

export default component.exports